import {sortEmployeesByName} from '../../../../utils';
import {BaselineCalendar} from '../BaselineCalendar';
import {LocationProgressBar} from '../LocationProgressBar';

export const LocationRow = ({
  org,
  isCollapsed,
  onToggleCollapse,
  getStatusLabel,
}) => {
  return (
    <div className='baseline-location-row'>
      <div className='baseline-location-content'>
        <div className='baseline-location-name'>
          <div
            className='baseline-location-name-text baseline-location-name-clickable'
            onClick={() => onToggleCollapse(org.location_name)}
          >
            <span
              className={`baseline-collapse-indicator ${isCollapsed ? 'collapsed' : 'expanded'}`}
            >
              ▼
            </span>
            {org.location_name}
          </div>
          <div className='baseline-location-stats'>
            <span className='baseline-stat-item completed'>
              Completed: {org.completed_count}
            </span>
            <span className='baseline-stat-item in-progress'>
              In Progress: {org.in_progress_count}
            </span>
            <span className='baseline-stat-item not-started'>
              Not Started: {org.not_started_count}
            </span>
          </div>
        </div>

        <div className='baseline-location-progress'>
          <LocationProgressBar
            completed={org.completed_count}
            total={org.total_employees}
          />
        </div>

        {!isCollapsed && (
          <div className='baseline-location-employees'>
            {org.employees && org.employees.length > 0 && (
              <>
                <div className='baseline-employee-details'>
                  <div className='baseline-employee-details-header'>
                    Employees ({org.employees.length})
                  </div>

                  {sortEmployeesByName(org.employees).map((employee) => (
                    <div
                      key={employee.employee_id}
                      className='baseline-employee-detail-row'
                    >
                      <div className='baseline-employee-detail-name'>
                        {employee.first_name} {employee.last_name}
                      </div>

                      <div className='baseline-employee-detail-progress'>
                        <div className='baseline-employee-shift-progress'>
                          <div className='baseline-shift-item'>
                            <span className='baseline-shift-label'>Pre:</span>
                            <span className='baseline-shift-value'>
                              {employee.pre_shift_completed}/
                              {employee.pre_shift_required}
                            </span>
                          </div>

                          <div className='baseline-shift-item'>
                            <span className='baseline-shift-label'>Post:</span>
                            <span className='baseline-shift-value'>
                              {employee.post_shift_completed}/
                              {employee.post_shift_required}
                            </span>
                          </div>
                        </div>

                        <span
                          className={`baseline-detail-status ${employee.status}`}
                        >
                          {getStatusLabel(employee.status)}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
                <BaselineCalendar orgId={org.org_id} />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
